import styled from 'styled-components';

const ToastPanel = styled.div`
    z-index: 1;
    pointer-events: none;
    background-color: transparent;
    justify-self: center;
    grid-column: controls-end / page-end;
    grid-row: toast-top / toast-bottom;

    /* Allow pointer events only on child elements */
    & > * {
        pointer-events: all;
    }
`;

export default ToastPanel;
